export const VOICE_BEHAVIOR_COPY = {
  title: 'Voice behavior',
  subtitle: 'Optional. These settings apply only when this tool is provided to a Voice agent.',
  waiting: 'Talk while waiting',
  messageType: 'Waiting message type',
  prompt: 'Prompt-generated',
  staticText: 'Static text',
  message: 'Waiting message',
  promptHint: 'Describe what the AI should say. Leave blank for a short, cautious waiting message.',
  staticHint: 'The AI reads this text as written, preserving your wording, spaces, and punctuation.',
  safetyHint: 'Keep waiting messages brief. Do not say an action succeeded before the tool finishes.',
  completion: 'Talk after completion',
  completionWarning: 'With completion speech off, the caller may be left waiting for a response.',
  typing: 'Typing sound',
  reset: 'Reset to defaults',
  defaults: 'Defaults: waiting speech off, completion speech on, typing sound on.',
  emptyStatic:
    'Enter a static waiting message. Turn on Talk while waiting to edit it, or reset to defaults.',
} as const satisfies Record<string, string>;
